export default "__VITE_ASSET__B163jwDx__"